export default {
  title: 'Godziny otwarcia i lokalizacja',
  set_different_opening_hours: 'Ustaw inne godziny otwarcia dla dostawy',
  delivery_opening_hours: 'Godziny otwarcia dostawy',
  sections: {
    general: 'Ogólne godziny otwarcia',
    holidays: 'Wstrzymaj zamówienia (święta)',
    create_time: 'Dodaj godzinę otwarcia',
    edit_time: 'Edytuj czas',
    delivery_schedule: 'Godziny otwarcia dostawy',
  },
  tabs: {
    open_times: 'Godziny otwarcia',
    location: 'Lokalizacja',
  },
  form: {
    select_all: {
      label: 'Zaznacz wszystkie dni',
    },
    holiday_starts_at: {
      label: 'Data rozpoczęcia',
    },
    holiday_ends_at: {
      label: 'Data zakończenia',
    },
    has_delivery_schedule: {
      label: 'Ustaw inne godziny otwarcia dla dostawy',
    },
    has_multiple_locations: {
      label: 'Ustaw różne lokalizacje na dany tydzień',
    },
  },
  labels: {
    day_location: '{{day}} lokalizacja {{index}}',
    selected_days: 'Wybrane dni',
    orders_paused: 'Zamówienia wstrzymane',
    open_time: 'Godzina otwarcia',
    close_time: 'Godzina zamknięcia',
  },
  errors: {
    close_time: 'Godzina zamknięcia nie może być 00:00. Wpisz 23:59',
  },
  buttons: {
    edit: 'Edytuj',
    add_schedule_unit: 'Dodaj godzinę otwarcia',
    add_holiday: 'Dodaj święto',
    delete: 'Usuń',
    save: 'Zapisz',
    cancel: 'Anuluj',
  },
  toasts: {
    changes_got_saved: 'Informacje zostały pomyślnie zaktualizowane',
    failed_to_save_changes: 'Nie udało się zapisać zmian',
  },
};
